export const genderI18n = (gender: string): string =>
  gender === 'male' ? '男性' : '女性'
